import auth from 'app/auth/store/reducers';
import { combineReducers } from 'redux';
import fuse from './fuse';
import user from './user';
import users from './users';
import notices from './notices';
import members from './members';
import mapping from './mapping';
import multipleCompanies from './multipleCompanies';
import devices from './devices';
import streaming from './streaming';
import projects from './projects';
import init from './initialization';
// import chat from './chat';
import notifications from './notifications';
import table from './table';
import session from './session';
import ctm from './ctm';
import calling from './calling';

const createReducer = asyncReducers =>
	combineReducers({
		auth,
		fuse,
		user,
		users,
		notices,
		members,
		mapping,
		multipleCompanies,
		devices,
		streaming,
		projects,
		init,
		//chat,
		notifications,
		table,
		session,
		ctm,
		calling,
		...asyncReducers
	});

export default createReducer;
